<template>
<div>
	<canvas id="can" height="500" width="500" style="border: 1px solid gray"></canvas>
	test
</div>
</template>
<script type="text/javascript">
export default {
	name: "CanvasTouchTest",
	data() {
		return {
			can: null,
			ctx: null,
			canX: null,
			canY: null,
			mouseIsDown: 0
		}
	},
	methods: {
		init() {
			this.can = document.getElementById("can");
            this.ctx = this.can.getContext("2d");
 
            this.can.addEventListener("mousedown", this.mouseDown, false);
            this.can.addEventListener("mousemove", this.mouseXY, false);
            this.can.addEventListener("touchstart", this.touchDown, false);
            this.can.addEventListener("touchmove", this.touchXY, true);
            this.can.addEventListener("touchend", this.touchUp, false);
 
            document.body.addEventListener("mouseup", this.mouseUp, false);
            document.body.addEventListener("touchcancel", this.touchUp, false);
		},
		mouseUp() {
            this.mouseIsDown = 0;
            this.mouseXY();
        },
 
        touchUp() {
            this.mouseIsDown = 0;
            // no touch to track, so just show state
            this.showPos();
        },
 
        mouseDown() {
            this.mouseIsDown = 1;
            this.mouseXY();
        },
 
        touchDown() {
            this.mouseIsDown = 1;
            this.touchXY();
        },
 
        mouseXY(e) {
            if (!e)
                var e = event;
            this.canX = e.pageX - this.can.offsetLeft;
            this.canY = e.pageY - this.can.offsetTop;
            this.showPos();
        },
 
        touchXY(e) {
            if (!e)
                var e = event;
            e.preventDefault();
            this.canX = e.targetTouches[0].pageX - this.can.offsetLeft;
            this.canY = e.targetTouches[0].pageY - this.can.offsetTop;
            this.showPos();
        },
 
        showPos() {
            // large, centered, bright green text
            this.ctx.font = "24pt Helvetica";
            this.ctx.textAlign = "center";
            this.ctx.textBaseline = "middle";
            this.ctx.fillStyle = "rgb(64,255,64)";
            var str = this.canX + ", " + this.canY;
            if (this.mouseIsDown)
                str += " down";
            if (!this.mouseIsDown)
                str += " up";
            this.ctx.clearRect(0, 0, this.can.width, this.can.height);
            // draw text at center, max length to fit on canvas
            this.ctx.fillText(str, this.can.width / 2, this.can.height / 2, this.can.width - 10);
            // plot cursor
            this.ctx.fillStyle = "white";
            this.ctx.fillRect(this.canX -5, this.canY -5, 10, 10);
        }
	},
	created() {
		setTimeout(() => {
			this.init()
		},1500)
	}
}
</script>